<template>
  <v-app-bar app color="surface" elevation="1" fixed class="navigation-bar-safe-area">
    <v-app-bar-nav-icon @click="toggleDrawer" class="menu-toggle">
      <v-icon>mdi-menu</v-icon>
    </v-app-bar-nav-icon>

    <div class="logo-wrapper">
      <img src="https://res.cloudinary.com/dzrldiajp/image/upload/w_50/v1765834427/vbzyvyi1lif0ub6dk9x2.png" alt="Logo" class="navbar-logo">
      <v-toolbar-title class="text-h6">
        cash.co.zm
      </v-toolbar-title>
    </div>

    <v-spacer></v-spacer>

    <NotificationBell class="me-2" />

    <v-switch
      v-model="isDarkMode"
      inset
      hide-details
      color="primary"
      :prepend-icon="isDarkMode ? 'mdi-weather-night' : 'mdi-weather-sunny'"
      class="theme-toggle"
    ></v-switch>

  </v-app-bar>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import NotificationBell from "@/components/notifications/NotificationBell.vue";

const store = useStore();
const emit = defineEmits(['toggle-drawer']);

const isDarkMode = computed({
  get: () => store.getters['theme/isDarkMode'],
  set: () => store.dispatch('theme/toggleTheme'),
});

function toggleDrawer() {
  emit('toggle-drawer');
}
</script>

<style scoped>
.navigation-bar-safe-area {
  padding-top: max(env(safe-area-inset-top), var(--safe-area-inset-top, 0px)) !important;
}

.menu-toggle {
  margin-right: 12px;
}

.theme-toggle {
  margin-left: 12px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.navbar-logo {
  height: 32px;
  width: auto;
  object-fit: contain;
}
</style>
